import { useEffect } from 'react'

import { useParams } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { useUmrahError } from 'entities/umrah/hooks/useUmrahError.tsx'
import umraListStore from 'entities/umrah/models/umrah-list.ts'
import { UmrahTourDetail } from 'entities/umrah/ui/umrah-detail'

import { Loader } from 'shared/ui/loader'

import s from './styles.module.scss'

const UmrahDetailPage = observer(() => {
  const { id, scheduleId } = useParams() as { id: string; scheduleId: string }
  const { showError } = useUmrahError()

  const tour = umraListStore.getUmrahTour()

  const getTour = async () => {
    try {
      await umraListStore.requestUmrahTour(id, scheduleId)
    } catch {
      showError()
    }
  }

  useEffect(() => {
    if (!tour) void getTour()
  }, [tour, id, scheduleId])

  return umraListStore.loading ? (
    <div className={s.loader}>
      <Loader />
    </div>
  ) : (
    tour && <UmrahTourDetail tour={tour} />
  )
})

export default UmrahDetailPage
